/**
 * Service worker bootstrapping.
 *
 * Only runs in production builds. Dev (`vite dev`) intentionally skips SW
 * registration so HMR isn't fighting a cached shell. Also skips during
 * Playwright runs — the trace viewer gets confused by SW intercepts.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;

  // Allow tests to opt out via a window flag the e2e harness can set.
  if ((window as unknown as { __disable_sw__?: boolean }).__disable_sw__) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('[lemma-pwa] service worker registration failed:', err);
    });
  });
}
